import { ConstructionFieldSpec, ConstructionModifier } from "../../api/constructionTypes";

// Shared dark-theme tokens for the construction UI.
export const C = {
  accent: "#00d4ad",
  accentHover: "#00b894",
  accentSoft: "rgba(0,212,173,0.14)",
  text: "#fff",
  dim: "rgba(255,255,255,0.65)",
  faint: "rgba(255,255,255,0.4)",
  panel: "rgba(255,255,255,0.03)",
  panelHover: "rgba(255,255,255,0.06)",
  border: "rgba(255,255,255,0.12)",
  danger: "#ff7676",
};

/** Compact number formatting for chips / previews. */
export function formatNum(n: number): string {
  if (!isFinite(n)) return String(n);
  if (Number.isInteger(n)) return String(n);
  const abs = Math.abs(n);
  if (abs !== 0 && abs < 0.01) return n.toExponential(1);
  return n.toFixed(2).replace(/\.?0+$/, "");
}

/** Symbol for a modifier operation. */
export function opSymbol(op: string): string {
  if (op === "set_baseline") return "=";
  if (op === "scale") return "×";
  if (op === "add") return "+";
  return op;
}

/** Plain-English-ish one-line summary of a single modifier. */
export function modifierSummary(
  m: ConstructionModifier,
  fieldByName: Map<string, ConstructionFieldSpec>
): string {
  const spec = fieldByName.get(m.field);
  const label = spec?.label ?? m.field;
  const units = spec?.units ? ` ${spec.units}` : "";
  return `${label} ${opSymbol(m.op)} ${formatNum(m.value)}${units}`;
}

/** Shared dark MUI input styling. */
export const inputSx = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: C.border },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.3)" },
    "&.Mui-focused fieldset": { borderColor: C.accent },
  },
  "& .MuiInputBase-input": { color: C.text },
  "& .MuiInputBase-inputMultiline": { color: C.text },
  "& .MuiSelect-icon": { color: C.dim },
  "& .MuiInputLabel-root": { color: C.dim },
  "& .MuiInputLabel-root.Mui-focused": { color: C.accent },
};

export const primaryBtnSx = {
  backgroundColor: C.accent,
  color: "#003b30",
  fontWeight: 600,
  textTransform: "none" as const,
  boxShadow: "none",
  "&:hover": { backgroundColor: C.accentHover, boxShadow: "none" },
  "&:disabled": {
    backgroundColor: "rgba(255,255,255,0.1)",
    color: "rgba(255,255,255,0.3)",
  },
};
